import APIConnector from "../lib/APIConnector";
import Settings from '../base/Settings'
const apiConnector = new APIConnector({ timeout: 30000 })

export default class StatsConfig {
  static get endpoint(){
    return Settings.SERVICE_DOMAIN
  }
  static get endpointStats() {
    return `${StatsConfig.endpoint}/stats`;
  }
  static get endpointStatsByClient() {
    return `${StatsConfig.endpointStats}/byClient`;
  }
  static get endpointStatsByClientDetail() {
    return `${StatsConfig.endpointStats}/byClientDetail`;
  }

  static get endpointStatsByEvent() {
    return `${StatsConfig.endpointStats}/byEvent`;
  }
  
  static get APIConnector() {
    return apiConnector
  }
}



// WEBPACK FOOTER //
// ./src/provider/stats/StatsConfig.js